import * as taskName from './task-name'
import * as processUI from '../../process-ui'
import { createUIDefinition } from '../default-task-definition'

export default createUIDefinition({
    taskName: taskName.SCAN_CUSTOMER,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.ANAMNESIS_LIST_WIDGET_CONTAINER,
        },
        {
            component: processUI.CUSTOMER_CONTACT_WIDGET,
        },
    ],
    overwriteWidget: true,
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/in-shop-scan/scan-customer.js